import styled, { css } from 'styled-components'
import { Row, Column } from '@sainsburys-tech/bolt'
import { themeContractM011 } from './M011.theme.contract'

const parseBorder = (width, style, borderColor) => {
  return ` border: ${width} ${style} ${borderColor}`
}

const Wrapper = styled(Row)`
  margin-bottom: ${(props) => props.theme.size.spacing.lg};
`

const CardContainer = styled(Row)`
  margin-left: ${(props) => props.theme.size.spacing[props.isSlider ? 'md' : 'lg']};
`

const Container = styled(Column)`
  min-height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) =>
    css`
      ${parseBorder(
        props.theme.size.border.width[themeContractM011[props.theme.channel].border.width],
        themeContractM011[props.theme.channel].border.style,
        props.theme.color.palette[themeContractM011[props.theme.channel].border.color]
      )};
      border-radius: ${props.theme.channel === 'nectar' ? props.theme.size.border.radius.base : 0};
      margin: 0 ${props.theme.size.spacing.lg} ${props.theme.size.spacing.lg} 0;
      background-color: ${props.theme.color.monochrome[themeContractM011[props.theme.channel].background.color]};
      img,
      picture {
        height: 100%;
        max-width: 100%;
        padding: 5px 0 5px 0;
      }
    `}
`

export { Wrapper, Container, CardContainer }
